import { GenericFormValidator } from 'main/common/form-state-manager/GenericFormValidator'
import { IsNotEmpty } from 'main/common/validation/decorators/IsNotEmpty'
import { Moment } from 'moment'
import { IsIn } from 'main/common/validation/decorators/IsIn'
import { PaymentMethodEnum } from 'submodules/neritclin-sdk/services/sale/paymentconfig/enums/PaymentMethodEnum'
import { IsOptional } from 'class-validator/decorator/decorators'

export class EditMultipleFinancialTransactionFormModel extends GenericFormValidator {

    @IsNotEmpty()
    changeExpirationDate: boolean

    @IsOptional()
    expirationDate: Moment

    @IsNotEmpty()
    changeReferenceDate: boolean

    @IsOptional()
    referenceDate: Moment

    @IsNotEmpty()
    changePaymentMethod: boolean

    @IsOptional()
    @IsIn(Object.values(PaymentMethodEnum))
    paymentMethod: PaymentMethodEnum

    @IsNotEmpty()
    changeBankAccount: boolean

    @IsOptional()
    bankAccountCode: number

    constructor(dto?: any) {
        super(dto)
        Object.assign(this, dto)
    }
}
